<template v-if="payrollInfo">
    <el-container direction="vertical" class="payroll-info-calculation">
        <el-row class="main main-block" v-loading="loading">
            <div class="title">
                {{ title }}
            </div>
            <div class="payroll-info-calculation-grid">
                <template v-for="(column, index) in headerColumnNames">
                    <div :key="'header_' + index" :class="column.fieldClass">
                        {{ column }}
                    </div>
                </template>
                <div>
                    Сделки
                </div>
                <div>
                    {{ dealsTotalSumAccrued ? formatFinance(dealsTotalSumAccrued) : 0 }}
                </div>
                <div>
                    {{ dealsTotalSumPaid ? formatFinance(dealsTotalSumPaid) : 0 }}
                </div>
                <div>
                    {{ dealsTotalSumResidue ? formatFinance(dealsTotalSumResidue) : 0 }}
                </div>
                <template v-for="(payrollInfoRow, payrollInfoRowName) in payrollInfo">
                    <div
                        :key="payrollInfoRowName+ 'name'"
                        :class="getBoldClass(payrollInfoRowName)"
                    >
                        {{ getEmployerCalculatedColumnName(payrollInfoRowName) }}
                    </div>
                    <div
                        :key="payrollInfoRowName+ '_accrued'"
                        class="nowrap"
                    >
                        <template>
                            {{ payrollInfoRow.accrued ? formatFinance(payrollInfoRow.accrued) : '' }}
                        </template>
                    </div>
                    <div
                        :key="payrollInfoRowName+ '_paid'"
                        class="nowrap"
                    >
                        <template>
                            {{ payrollInfoRow.paid ? formatFinance(payrollInfoRow.paid) : '' }}
                        </template>
                    </div>
                    <div
                        :key="payrollInfoRowName+ '_residue'"
                        class="nowrap"
                    >
                        <template>
                            {{ payrollInfoRow.residue ? formatFinance(payrollInfoRow.residue) : 0 }}
                        </template>
                    </div>
                </template>
                <div class="bold">
                    Итого:
                </div>
                <div class="bold">
                    {{ totalCalculateSumAccrued ? formatFinance(totalCalculateSumAccrued) : 0 }}
                </div>
                <div class="bold">
                    {{ totalCalculateSumPaid ? formatFinance(totalCalculateSumPaid) : 0 }}
                </div>
                <div class="bold">
                    {{ totalCalculateSumResidue ? formatFinance(totalCalculateSumResidue) : 0 }}
                </div>
            </div>
        </el-row>
    </el-container>
</template>
<script>
import { formatFinance } from '@/common/utilities';
import '@/assets/styles/payroll-info-calculate.scss';
import employerInfoMixin from '@/mixins/employerInfo';
import dateHelper from '@/helpers/dateHelper';

export default {
    name: 'PayrollInfoEmployerCalculate',
    props: {
        employerId: {
            type: [Number, String],
            default: 0
        },
        reportDate: {
            type: String,
            default: ''
        }
    },
    mixins: [
        employerInfoMixin
    ],
    data() {
        return {
            amount: [],
            loading: false,
            payrollInfo: [],
            total: [],
            employerPositionId: 0,
            headerColumnNames: [
                'Статья', 'Начислено', 'Выдано', 'К выдаче'
            ],
            totalAccrued: 0,
            isDataLoaded: false
        };
    },
    methods: {
        formatFinance,
        async calculateTotal(period, employerId) {
            this.loading = true;
            await this.$store.dispatch('salary/calculateTotal', { report_date: period, employer_id: employerId }).then(
                response => {
                    this.payrollInfo = response.totalInfo;
                    this.total = response.total;
                    const totalSum = {
                        accrued: this.total.accrued,
                        paid: this.total.paid,
                        residue: this.total.accrued - this.total.paid
                    };
                    this.$store.dispatch('salary/setTotalCalculateSum', { totalSum });
                    this.isDataLoaded = true;
                    this.employerPositionId = response.employerPositionId;
                    console.log(this.payrollInfo);
                },
                error => {
                    if (error.response.status === 403) {
                        console.log(error.response.data.error);
                    }
                }
            ).finally(() => { this.loading = false; });
        },
        getEmployerCalculatedColumnName(columnName) {
            return this.getNameFromListById(this.payrollInfoEmployerCalculateFields, columnName);
        },
        getNameFromListById(list, searchedId) {
            if (Object.keys(list).length !== 0) {
                if (searchedId === 'efficiency_payment') {
                    if (this.employerPositionId === this.localReferences.employerPositions.manager) {
                        searchedId = 'efficiency_payment_manager';
                    } else if (this.employerPositionId === this.localReferences.employerPositions.measurer) {
                        searchedId = 'efficiency_payment_measurer';
                    }
                }
                const foundItem = list.find(item => item.id === searchedId);
                return foundItem ? foundItem.name : '';
            }
            return '';
        },
        toFixed(item) {
            item = parseFloat(item);
            return item.toFixed(2);
        },
        getBoldClass(columnName) {
            return columnName === 'total' ? 'bold' : '';
        },
        getAccruedTotal() {
            return parseInt(this.payrollInfo.salary_cashless.accrued) + parseInt(this.payrollInfo.salary_cash.accrued) + parseInt(this.payrollInfo.prepayment.accrued) + ('bonus' in this.payrollInfo ? parseInt(this.payrollInfo.bonus.accrued) : 0) + parseInt(this.payrollInfo.fine.accrued) + ('efficiency_payment' in this.payrollInfo ? parseInt(this.payrollInfo.efficiency_payment.accrued) : 0) + parseInt(this.payrollInfo.debts_previous_periods.accrued);
        }
    },
    computed: {
        title() {
            const date = this.reportDate.split('-');
            return 'Расчёт к выдаче за ' + dateHelper.getMonthName(date[1]) + ' ' + date[0];
        },
        dealsTotalSumAccrued() {
            if (!this.isDataLoaded) return 0;
            return this.$store.state.salary.dealsTotalSum.accrued ? this.$store.state.salary.dealsTotalSum.accrued : 0;
        },
        dealsTotalSumPaid() {
            if (!this.isDataLoaded) return 0;
            return this.$store.state.salary.dealsTotalSum.paid;
        },
        dealsTotalSumResidue() {
            return this.$store.state.salary.dealsTotalSum.residue;
        },
        totalCalculateSumAccrued() {
            if (!this.isDataLoaded) return 0;
            return this.$store.state.salary.totalCalculateSum.accrued ? this.$store.state.salary.totalCalculateSum.accrued : this.getAccruedTotal() + this.total.accrued;
        },
        totalCalculateSumPaid() {
            if (!this.isDataLoaded) return 0;
            return this.$store.state.salary.totalCalculateSum.paid;
        },
        totalCalculateSumResidue() {
            return this.$store.state.salary.totalCalculateSum.residue;
        }
    },
    mounted() {
        this.calculateTotal(this.reportDate, this.employerId);
    },
    beforeDestroy() {
        this.$store.commit('salary/clearStore');
    },
    watch: {
        dealsTotalSumAccrued: function(dealsTotalSumAccrued) {
            if (!dealsTotalSumAccrued) {
                return;
            }
            if (!this.isDataLoaded) {
                return;
            }
            const totalSum = {};
            totalSum.accrued = parseInt(dealsTotalSumAccrued) + this.getAccruedTotal();
            totalSum.paid = parseInt(this.total.paid) + parseInt(this.dealsTotalSumPaid);
            totalSum.residue = totalSum.accrued - totalSum.paid;
            this.$store.dispatch('salary/setTotalCalculateSum', { totalSum });
        }
    }
};
</script>
